import React from 'react';
import { FaSignOutAlt } from 'react-icons/fa';
import useAuth from '../hooks/useAuth';

const LogoutButton = ({ 
  className = "", 
  style = {},
  showIcon = true, 
  buttonText = "Déconnexion",
  variant = "danger" // primary, secondary, success, danger, warning, info, light, dark
}) => {
  const { deconnexion, userType } = useAuth();

  const handleLogout = () => {
    if (window.confirm('Êtes-vous sûr de vouloir vous déconnecter ?')) {
      deconnexion();
    }
  };

  const baseStyle = {
    padding: '8px 16px',
    borderRadius: '5px',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '14px',
    fontWeight: '500',
    transition: 'all 0.2s ease',
    ...style
  };

  // Styles selon le variant
  const variants = {
    primary: { backgroundColor: '#007bff', color: 'white' },
    secondary: { backgroundColor: '#6c757d', color: 'white' },
    success: { backgroundColor: '#28a745', color: 'white' },
    danger: { backgroundColor: '#dc3545', color: 'white' },
    warning: { backgroundColor: '#ffc107', color: '#212529' },
    info: { backgroundColor: '#17a2b8', color: 'white' },
    light: { backgroundColor: '#f8f9fa', color: '#212529', border: '1px solid #dee2e6' },
    dark: { backgroundColor: '#343a40', color: 'white' }
  };

  const buttonStyle = {
    ...baseStyle,
    ...variants[variant]
  };

  return (
    <button
      onClick={handleLogout}
      className={className}
      style={buttonStyle}
      onMouseEnter={(e) => {
        e.target.style.opacity = '0.8';
      }}
      onMouseLeave={(e) => {
        e.target.style.opacity = '1';
      }}
      title={`Déconnexion ${userType === 'expert' ? 'Expert' : 'Client'}`}
    >
      {showIcon && <FaSignOutAlt />}
      {buttonText}
    </button>
  );
};

export default LogoutButton;